import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Components(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Components</h2>
                <li>
                    <Link to={`${url}/springs`}>Springs</Link>
                </li>
                <li>
                    <Link to={`${url}/gears`}>Gears and Gearboxes</Link>
                </li>
                <li>
                    <Link to={`${url}/bearings`}>Bearings and Mounts</Link>
                </li>
             
              
                <li>
                    <Link to={`${url}/shafts`}>Shafts and Keys</Link>
                </li>
                <li>
                    <Link to={`${url}/stock`}>Stock Material</Link>
                </li>  
                <li>
                    <Link to={`${url}/tubing`}>Tubing & Connectors</Link>
                </li>
                <li>
                    <Link to={`${url}/pumps`}>Pumps & Compressors</Link>
                </li>
                <li>
                    <Link to={`${url}/valves`}>Valves</Link>
                </li>    
                <li>
                    <Link to={`${url}/cylinders`}>Cylinders</Link>
                </li>           
                  <li>
                    <Link to={`${url}/flywheels`}>Flywheels</Link>
                </li>     
                     <li>
                    <Link to={`${url}/latches`}>Latches</Link>
                </li>   
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Components; 